export default "__VITE_ASSET__D1F1SLxs__"